import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import timepicker from 'vendor/timepicker.js';
import EmployeeActions from 'actions/EmployeeActions.js';
import ConfirmationActions from 'actions/ConfirmationActions.js';
import OfflineTooltip from 'components/OfflineTooltip';

const DEFAULT_STATE = {
  savedTimes: []
};

class SidebarSetAvailability extends React.Component {
  constructor(props) {
    super(props);

    this.onSaveTime = this.onSaveTime.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onAllDayAvailability = this.onAllDayAvailability.bind(this);
    this.onCreateError = this.onCreateError.bind(this);

    this.savedShifts = [];

    this.state = $.extend({}, DEFAULT_STATE);
  }

  componentDidMount() {
    const args = {
      format: true,
      meridiem: false,
      increment: 5,
    };

    if (ReactDOM.findDOMNode(this).querySelector('input#availability-start')) {
      const startTimepicker = new timepicker(
        document.querySelector('input#availability-start'),
        args,
      );
    }

    if (ReactDOM.findDOMNode(this).querySelector('input#availability-end')) {
      const endTimepicker = new timepicker(document.querySelector('input#availability-end'), args);
    }
    AvailabilitiesStore.on(
      'availability:delete:success',
      function (collection, response) {
        this.setState($.extend({}, DEFAULT_STATE));
      },
      this,
    );

    AvailabilitiesStore.on(
      'availability:create:success',
      function (collection, response) {
        this.setState($.extend({}, DEFAULT_STATE));
      },
      this,
    );

    AvailabilitiesStore.on('availability:create:error', this.onCreateError);
  }

  componentWillUnmount() {
    AvailabilitiesStore.off('availability:create:error', this.onCreateError);
  }

  componentWillReceiveProps() {
    if (ReactDOM.findDOMNode(this).querySelector('input#availability-start')) {
      ReactDOM.findDOMNode(this).querySelector('input#availability-start').value = '';
    }

    if (ReactDOM.findDOMNode(this).querySelector('input#availability-end')) {
      ReactDOM.findDOMNode(this).querySelector('input#availability-end').value = '';
    }

    if (ReactDOM.findDOMNode(this).querySelector('form#add-availability-form')) {
      ReactDOM.findDOMNode(this).querySelector('form#add-availability-form').parentNode.classList.remove('error');
    }

    if (ReactDOM.findDOMNode(this).querySelector('.error-message')) {
      ReactDOM.findDOMNode(this).querySelector('.error-message').innerHTML = '';
    }

    this.setState( $.extend({}, DEFAULT_STATE));
  }

  onCreateError(response) {
    const form = ReactDOM.findDOMNode(this).querySelector('form#add-availability-form');
    form.parentNode.classList.add('error');
    const message = response && response.responseJSON && response.responseJSON.error_message;
    ReactDOM.findDOMNode(this).querySelector('.error-message').innerHTML = message || '';
  }

  onAllDayAvailability(e) {
    const start = '12:00 am';
    const end = '12:00 am';

    const startMoment = Utils.companyTimezoneOffset(
      moment(new Date(this.props.selectedDate).setHours(0, 0, 0, 0)),
    );
    const endMoment = Utils.companyTimezoneOffset(
      moment(new Date(this.props.selectedDate).setHours(0, 0, 0, 0)).add(1, 'day'),
    );

    const startUnix = moment
      .tz(
        startMoment.format('DD/MM/YYYY HH:mm'),
        'DD/MM/YYYY HH:mm',
        Utils.getCoreUser().inferred_time_zone,
      )
      .unix();
    const endUnix = moment
      .tz(
        endMoment.format('DD/MM/YYYY HH:mm'),
        'DD/MM/YYYY HH:mm',
        Utils.getCoreUser().inferred_time_zone,
      )
      .unix();

    EmployeeActions.createAvailability(startUnix, endUnix);
  }

  onInputFocus(e) {
    const form = ReactDOM.findDOMNode(this).querySelector('form#add-availability-form');
    form.parentNode.classList.remove('error');
  }

  onSaveTime(e) {

    const form = ReactDOM.findDOMNode(this).querySelector('form#add-availability-form');
    if (!Utils.isNotDefined(form)) {
      const start = ReactDOM.findDOMNode(this).querySelector('input#availability-start').value;
      const end = ReactDOM.findDOMNode(this).querySelector('input#availability-end').value;

      if (start == '' || end == '') {
        form.parentNode.classList.add('error');
        ReactDOM.findDOMNode(this).querySelector('.error-message').innerHTML = this.props.t('SidebarSetAvailability.times_invalid');
        return;
      } else if (start == end && e.actionType != appConstants.ActionTypes.CONFIRM_ACTION) {
        this.confirm();
        return;
      }

      let startMoment = Utils.companyTimezoneOffset(
        moment(new Date(`${new Date(this.props.selectedDate).toDateString()} ${start}`)),
      );
      let endMoment = Utils.companyTimezoneOffset(
        moment(new Date(`${new Date(this.props.selectedDate).toDateString()} ${end}`)),
      );

      if ( startMoment > endMoment || (start == end && e.actionType == appConstants.ActionTypes.CONFIRM_ACTION) ) {
        startMoment = Utils.companyTimezoneOffset(
          moment(new Date(`${new Date(this.props.selectedDate).toDateString()} ${start}`)),
        );
        endMoment = Utils.companyTimezoneOffset(
          moment(new Date(`${new Date(this.props.selectedDate).toDateString()} ${end}`)).add(
            1,
            'days',
          ),
        );
      }
      const startUnix = moment
        .tz(
          startMoment.format('DD/MM/YYYY HH:mm'),
          'DD/MM/YYYY HH:mm',
          Utils.getCoreUser().inferred_time_zone,
        )
        .unix();
      const endUnix = moment
        .tz(
          endMoment.format('DD/MM/YYYY HH:mm'),
          'DD/MM/YYYY HH:mm',
          Utils.getCoreUser().inferred_time_zone,
        )
        .unix();
      EmployeeActions.createAvailability(startUnix, endUnix);

      this.savedShifts.push({ shift: `${start} - ${end}`, id: null });
    }
  }

  confirm() {
    ConfirmationActions.confirm({
      header: this.props.t('SidebarSetAvailability.confirm'),
      body: this.props.t('SidebarSetAvailability.confirm_copy'),
      confirmation_cb: this.onSaveTime
    });    
  }

  getDateFromTime(time) {
    return new Date(`${Date.now().toDateString()} ${time}`);
  }

  onDeleteAvailableShift(id, recurring_id) {
    if (recurring_id) {
      EmployeeActions.deleteRecurringAvailability(id, recurring_id);
      return null;
    }
    if (!Utils.isNotDefined(id)) {
      EmployeeActions.deleteAvailability(id);
    }
  }

  partialPickers() {
    const timePickerStart = (
      <input
        id="availability-start"
        className="timepicker"
        placeholder={this.props.t('SidebarSetAvailability.start')}
        name="start-time"
        onClick={this.onInputFocus}
      />
    );
    const timePickerEnd = (
      <input
        id="availability-end"
        placeholder={this.props.t('SidebarSetAvailability.end')}
        className="timepicker"
        name="end-time"
        onClick={this.onInputFocus}
      />
    );
    const timePickerSave = (
      <OfflineTooltip>
        <input
          type="button"
          value={this.props.t('SidebarSetAvailability.save')}
          className="light"
          id="availability-time-save"
          onClick={this.onSaveTime}
          disabled={!Utils.isOnline()}
        />
      </OfflineTooltip>
    );

    return (
      <form id="add-availability-form">
        <div className="time">
          <div className="time__input">{timePickerStart}</div>
        </div>
        <p>{this.props.t('SidebarSetAvailability.to')}</p>
        <div className="time">
          <div className="time__input">{timePickerEnd}</div>
        </div>
        {timePickerSave}
      </form>
    );
  }

  render() {
    const that = this;
    const shifts = [];
    const today = moment(new Date().setHours(0, 0, 0, 0));

    if (this.props.availableShifts && this.props.availableShifts.length > 0) {
      const len = this.props.availableShifts.length;
      for (let i = 0; i < len; i++) {
        const startPush = moment
          .unix(this.props.availableShifts[i].starts_at)
          .tz(Utils.getCoreUser().inferred_time_zone)
          .format('h:mm a');
        const endPush = moment
          .unix(this.props.availableShifts[i].ends_at)
          .tz(Utils.getCoreUser().inferred_time_zone)
          .format('h:mm a');
        let shiftLabel = `${startPush} - ${endPush}`;
        if (shiftLabel == '12a - 12a' || shiftLabel == '12:00 am - 12:00 am') {
          shiftLabel = this.props.t('SidebarSetAvailability.all_day');
        }
        if (!Utils.isNotDefined(this.props.availableShifts[i].id)) {
          if (moment(this.props.selectedDate).isBefore(today)) {
            shifts.push(
              <li className="availability-time-shift" key={this.props.availableShifts[i].id}>
                {shiftLabel}
                <span
                  className="delete-item disabled"
                  data-avail-id={this.props.availableShifts[i].id}
                />
              </li>,
            );
          } else {
            const isOnline = Utils.isOnline();
            shifts.push(
              <li className="availability-time-shift" key={this.props.availableShifts[i].id}>
                {shiftLabel}
                <span
                  className={`delete-item${isOnline ? '' : ' disabled'}`}
                  data-avail-id={this.props.availableShifts[i].id}
                  onClick={isOnline ? () => {
                    const shift = this.props.availableShifts[i]
                    if (shift.hasOwnProperty('recurring_availability_id')) {
                      that.onDeleteAvailableShift(shift.id, shift.recurring_availability_id)
                      return null;
                    }
                    that.onDeleteAvailableShift(shift.id);
                  } : undefined}
                >
                  <img src={window.EmployeeWeb.ENVConfig.x_icon} />
                </span>
              </li>,
            );
          }
        }
      }
    }

    // let classes =  'calendar-input add-availability ' + (!this.props.active ? 'hide' : '');
    const classes = 'calendar-input add-availability';

    let allDayButton = null;
    let divider = '';
    if (this.props.showAllDay && !moment(this.props.selectedDate).isBefore(today)) {
      allDayButton = (
        <OfflineTooltip>
          <button
            className="calendar-input-button all-day-button"
            onClick={this.onAllDayAvailability}
            disabled={!Utils.isOnline()}
          >
            {this.props.t('SidebarSetAvailability.all_day')}
          </button>
        </OfflineTooltip>
      );
      divider = (
        <div className="hr-label">
          <span />
          {this.props.t('SidebarSetAvailability.or')}
          <span />
        </div>
      );
    }

    let partialPickers = null;
    if (!moment(this.props.selectedDate).isBefore(today)) {
      partialPickers = this.partialPickers();
    }

    let timePickerStart = (
      <input
        id="availability-start"
        className="timepicker"
        placeholder={this.props.t('SidebarSetAvailability.start')}
        name="start-time"
        onClick={this.onInputFocus}
      />
    );
    let timePickerEnd = (
      <input
        id="availability-end"
        placeholder={this.props.t('SidebarSetAvailability.end')}
        className="timepicker"
        name="end-time"
        onClick={this.onInputFocus}
      />
    );
    let timePickerSave = (
      <input
        type="button"
        value={this.props.t('SidebarSetAvailability.save')}
        className="light"
        id="availability-time-save"
        onClick={this.onSaveTime}
      />
    );
    if (moment(this.props.selectedDate).isBefore(today)) {
      timePickerStart = (
        <input
          id="availability-start"
          className="timepicker picker__list-item--disabled"
          placeholder={this.props.t('SidebarSetAvailability.start')}
          name="start-time"
          readOnly
        />
      );
      timePickerEnd = (
        <input
          id="availability-end"
          placeholder={this.props.t('SidebarSetAvailability.end')}
          className="timepicker picker__list-item--disabled"
          name="end-time"
          readOnly
        />
      );
      timePickerSave = (
        <input
          type="button"
          value={this.props.t('SidebarSetAvailability.save')}
          className="light disabled"
          id="availability-time-save"
          disabled
        />
      );
    }

    // If there aren't any pickers or shifts to render, return an empty div
    const showAll = allDayButton || partialPickers || shifts.length > 0;
    if (!showAll) {
      return <div />;
    }

    return (
      <div className={classes}>
        <span className="calendar-input-bullet availability-bullet with-help">
          {this.props.t('SidebarSetAvailability.availability')}
        </span>
        <br />
        {allDayButton}
        {divider}
        {partialPickers}
        <div className="error-message" />
        {shifts.length > 0 && (
          <div className="data-list shifts">
            <ul>{shifts}</ul>
          </div>
        )}
      </div>
    );
  }
}

export default translate()(SidebarSetAvailability);
